export default function MemoryCard({ handleClick, data, selectedIds }) {
  const totalCards = data.length

  function getGridDimensions(cardCount) {
    if (cardCount <= 0) return { rows: 2, cols: 2 }

    // Start near-square, then prefer a wider grid when it removes empty cells (e.g. 10 → 5×2 not 4×3).
    let cols = Math.ceil(Math.sqrt(cardCount))
    let rows = Math.ceil(cardCount / cols)
    rows = Math.min(rows, 8)

    while (rows * cols > cardCount && rows > 1) {
      const nextRows = rows - 1
      const nextCols = Math.ceil(cardCount / nextRows)
      if (nextRows * nextCols < cardCount) break
      rows = nextRows
      cols = nextCols
    }

    while (rows * cols < cardCount) cols += 1

    return { rows, cols }
  }

  const { rows: gridRows, cols: gridCols } = getGridDimensions(totalCards)

  const emojiEl = data.map((card) => {
    const isSelected = selectedIds?.has(card.id)
    const isMatched = card.isMatched
    const isFlipped = isSelected || isMatched

    const isFlag = card.type === 'flag'
    const isSightseeing = card.type === 'sightseeing'

    return (
      <li
        key={card.id}
        className={[
          'card-item',
          isSelected ? 'card-item--selected' : null,
          isMatched ? 'card-item--matched' : null,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <button
          className={[
            'btn',
            'btn--emoji',
            isFlipped ? 'btn--emoji__back--selected' : 'btn--emoji__front',
            isMatched ? 'btn--emoji__back--matched' : null,
          ]
            .filter(Boolean)
            .join(' ')}
          type="button"
          aria-pressed={isFlipped}
          aria-disabled={isMatched}
          disabled={isMatched}
          onClick={() => handleClick(card.id)}
        >
          <span className="sr-only">
            {isMatched ? 'Matched' : isSelected ? 'Selected' : 'Hidden'} card
            {isFlipped &&
              isSightseeing &&
              `: ${card.city}${isMatched ? `, ${card.landmark ?? card.name}` : ''}`}
            {isFlipped &&
              isFlag &&
              `: ${card.name}${isMatched && card.capital ? `, ${card.capital}` : ''}`}
          </span>
          {!isFlipped && '❓'}
          {isFlipped && isFlag && (
            <span className="card-face" aria-hidden="true">
              <span className="card-face__media">
                <span className={`fi fi-${card.code}`} />
              </span>
              {isFlipped && (
                <span className="card-face__label card-face__label--overlay">
                  <span className="card-face__label-primary">{card.name}</span>
                  {isMatched && card.capital ? (
                    <span className="card-face__label-sub">{card.capital}</span>
                  ) : null}
                </span>
              )}
            </span>
          )}
          {isFlipped && isSightseeing && (
            <span className="card-face" aria-hidden="true">
              <span className="card-face__media">
                <img
                  className="card-face__img"
                  src={card.image}
                  alt=""
                  loading="eager"
                  decoding="async"
                  draggable={false}
                />
              </span>
              {isFlipped && (
                <span className="card-face__label card-face__label--overlay">
                  <span className="card-face__label-primary">{card.city}</span>
                  {isMatched && (card.landmark ?? card.name) ? (
                    <span className="card-face__label-sub">{card.landmark ?? card.name}</span>
                  ) : null}
                </span>
              )}
            </span>
          )}
        </button>
      </li>
    )
  })

  return (
    <ul
      className="card-container"
      style={{ '--grid-cols': gridCols, '--grid-rows': gridRows }}
    >
      {emojiEl}
    </ul>
  )
}